<template>
  <b-modal ref="modalAjoutProduitComplementaire" size="xl" scrollable
    :title="titreModal" 
    :ok-title="titreBoutonOk"
    cancel-title="Annuler"
    :ok-disabled="!ajouterOK || (!produitEstModifiee)"
    no-close-on-backdrop
    @ok="enregistrerProduit()"
    @show="initialiserModale()"
  >
    <div style="display: inline">
        <div class="container-fluid card card-body">
          <!--<h4 class="push-bottom-2rem">Informations produit</h4>-->
          <div class="row">
            <div class="col-6 form-group">
              <label>Famille du produit</label>
              <v-select id="selFamille" :disabled="true" v-model="familleSelect" :options="optionsFamilles" value="valeur" label="texte" :clearable="false">
              </v-select>
            </div>
            <div class="col-6 form-group">
              <label class="push-right-2rem">Fournisseur</label>
              <v-select :disabled="true" v-model="fournisseurSelect" :options="optionsFournisseurs" value="valeur" label="texte" :clearable="false">
              </v-select>
            </div>
          </div>

          <div class="row">
            
            <div class="col-4 form-group">
              <label>Ingrédient</label>
              <RechercheCompleteProduits ref="refChercherIngredient" :disabled="rechercheIngredientDisabled" :chercherIngredients="true" :chercherProduits="true" :afficherPrix="false" @input="key++;majIngredientSelect();" @reset="resetIngredient()" v-model="ingredientSelect" :initValeur="vueProduitComplementaire.ingredient" />
            </div>

            <div class="col-8 form-group">
              <label class="push-right-2rem">Désignation</label>
              <input :disabled="!mercurialeModifiable" type="text" title="Description du produit pour le fournisseur" v-model.trim="vueProduitComplementaire.designation" style="width:100%" @input="key++;"/>
              <div class="error" v-if="!vueProduitComplementaire.designation">Ce champ est requis</div>
              <div v-else>&nbsp;</div>
            </div>
          </div>

          <div class="row">
            <div class="col-3 form-group">
              <label>Marque</label>
              <input :disabled="!mercurialeModifiable" type="text" v-model.trim="vueProduitComplementaire.marque" style="width:100%" @input="key++;"/>
              <div>&nbsp;</div>
            </div>
            <div class="col-3 form-group">
              <label>Référence</label>
              <input :disabled="!mercurialeModifiable" type="text" v-model.trim="vueProduitComplementaire.reference" style="width:100%" @input="key++;"/>
              <div>&nbsp;</div>
            </div>
            <div class="col-6 form-group">
              <label>Allergènes</label>
              <MultiSelect v-model="vueProduitComplementaire.allergenesMajeurs" :items="optionsAllergenes" itemText="valeur" itemValue="id" emptyText="Tous les allergènes ont été ajoutés" @change="key++;"/>
              <div class="error" v-if="(!vueProduitComplementaire.allergenesMajeurs || vueProduitComplementaire.allergenesMajeurs.length === 0)">Ce champ est requis</div>
              <div class="error" v-else-if="allergenesKO">Vous ne pouvez pas sélectionner 'Aucun Allergène' avec d'autres allergènes</div>
              <div v-else>&nbsp;</div>
            </div>
          </div>

          <div class="row">
            <div class="col-4 form-group">
              <label>PCB</label>
              <div class="flex-start">
                <InputNumber :disabled="!mercurialeModifiable" typeFiltre="quantite" v-model="vueProduitComplementaire.pcb" style="margin-right:2px" @input="key++;" />
                <v-select :disabled="!mercurialeModifiable" id="selUC" v-model="ucSelect" :options="optionsUC" value="id" label="nom" style="margin-left:2px;width:200px" :clearable="false" @input="selectUCDeProduit($event);key++;">
                </v-select>
              </div>
              <div class="error" v-if="(!vueProduitComplementaire.pcb || !ucSelect.id)">Ces champs sont requis</div>
              <div v-else>&nbsp;</div>
            </div>

            <div class="col-4 form-group">
              <label>P.U. HT</label>
              <div class="flex-start">
                <InputNumber :disabled="!mercurialeModifiable" typeFiltre="montant" v-model="vueProduitComplementaire.prixUnitaireHT" v-tooltip="{ content: 'Prix Unitaire (selon PCB)', placement: 'top' }" @input="key++;"/>
                <div class="input-group-append">
                  <span class="input-group-text">€{{ this.unitePrix(1) }}</span>
                </div>
              </div>
              <div class="error" v-if="!vueProduitComplementaire.prixUnitaireHT">Ce champ est requis</div>
              <div v-else>&nbsp;</div>
            </div>
            <div class="col-4 form-group">
              <label>Montant HT</label>
              <div class="flex-center-center input-group-text">
                {{ montantHT }}
              </div>
              <div>&nbsp;</div>
            </div>
            
            <div class="col-1 form-group"></div>
          </div>

          <div class="row">
            <div class="col-4 form-group">
              <label>Taux TVA</label>
              <div class="flex-start">
                <v-select :disabled="!mercurialeModifiable" id="selTVA" v-model="tvaSelect" :options="optionsTVA" value="id" label="nom" style="margin-left:2px;width:200px" :clearable="false" @input="selectTVA($event);key++;"></v-select>
                <div class="input-group-append">
                  <span class="input-group-text"> %</span>
                </div>
              </div>
            </div>

            <div class="col-4 form-group">
              <label>P.U. TTC</label>
              <div class="flex-center-center input-group-text">
                {{ puTTC }} €{{ this.unitePrix(1) }}
              </div>
            </div>
            <div class="col-4 form-group">
              <label>Montant TTC</label>
              <div class="flex-center-center input-group-text">
                {{ montantTTC }}
              </div>
            </div>
          </div>

        </div>
        <div class="container-fluid card card-body">
          <div class="row">
            <div class="col-12 form-group">
              <label>Paramétrage pour les recettes</label>
            </div>
          </div>
          <div class="row">
            <div class="col-1 form-group">
              <!-- <label>Poids de la portion</label>
              <div class="flex-start">
                <InputNumber class="mr-1" typeFiltre="quantite" v-model="produitHM.grammage"/>
                <div class="input-group-append">
                  <span class="input-group-text">g</span>
                </div>
              </div>
              <div>&nbsp;</div> -->
            </div>

            <div class="col-10 form-group">
              <p>Contenu du produit :</p>
              <div v-if="(vueProduitComplementaire.pcb && ucSelect.id)" class="flex-center-center">
                <div class="input-group-prepend">
                  <span class="input-group-text " >Dans {{vueProduitComplementaire.pcb}} {{plurielUC(vueProduitComplementaire.pcb, vueProduitComplementaire.uc)}} je vais avoir </span>
                </div>
                <input type="number" v-model="vueProduitComplementaire.nbPCE" class="saisieRepartition form-control" style="margin:2px;width:65px;text-align:right;" @input="key++;"/>
                <div class="input-group-append">
                  <span class="input-group-text">{{ plurielUC(vueProduitComplementaire.nbPCE, 'Pièce') + ', '}}</span>
                </div>
                <input type="number" v-model="vueProduitComplementaire.nbKg" class="saisieRepartition form-control" style="margin:2px;width:65px;text-align:right;" @input="key++;"/>
                <div class="input-group-append">
                  <span class="input-group-text">Kg, </span>
                </div>
                <input type="number" v-model="vueProduitComplementaire.nbL" class="saisieRepartition form-control" style="margin:2px;width:65px;text-align:right;" @input="key++;"/>
                <div class="input-group-append">
                  <span class="input-group-text">{{ plurielUC(vueProduitComplementaire.nbL, 'Litre')}}</span>
                </div>
              </div>
              <span class="input-group-text flex-center-center" v-else>Veuillez renseigner le PCB</span>
              <!--</label>-->
              <div style="height:50px" class="flex-center-center">
                <div v-if="repartitionOK && (vueProduitComplementaire.pcb && ucSelect.id)">
                  <em>
                    <p>{{phraseConversion(vueProduitComplementaire, vueProduitComplementaire, vueProduitComplementaire.pcb) || "Pas de répartition."}}</p>
                    <p>{{phraseConversion(vueProduitComplementaire, vueProduitComplementaire, 1.5 * vueProduitComplementaire.pcb)}}</p>
                  </em>
                </div>
                <div v-else-if="(vueProduitComplementaire.pcb && ucSelect.id)">
                  <em>
                    <p>Pas de répartition.</p>
                  </em>
                </div>
              </div>
            </div>
            <div class="col-1 form-group"></div>
          </div>
          
        </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex"
import { constantesId } from "@/helpers/constantes"
import { showAlerts } from "@/mixins/alerts"
import { ajouterModifierProduitComplementaire } from '@/api/gpao/mercuriales'
import { arrondiPrixPCB, arrondiNombre, plurielUC, phraseConversion } from '@/helpers/utils'
import { connecteData } from "@/mixins/connecteData"
import RechercheCompleteProduits from "@/components/Mercuriales/RechercheCompleteProduits"
import InputNumber from '@/components/Inputs/InputNumber'
import MultiSelect from "@/components/Inputs/MultiSelect"
import { formatageDate, formatHumanDateAvecSlashes } from '@/mixins/dateFormats'
import _ from 'lodash'

export default {
  name: "ModalAjoutProduitComplementaire",
  props: [ 'produitComplementaire', 'paramModale', 'optionsUC' ],
  mixins: [
    showAlerts,
    connecteData,
    formatageDate,
    formatHumanDateAvecSlashes
  ],
  components: {
    InputNumber,
    RechercheCompleteProduits,
    MultiSelect
  },
  data() {
    return {
      key: 1,
      optionsAllergenes: constantesId.allergenes,
      ajoutProduit: false,
      modifierProduit: false,
      dupliquerProduit: false,
      rechercheIngredientDisabled: false,
      fournisseurFixeId: null,
      dateDebutTarifSelectionneeFormat : null,
      dateDebutTarifSelectionnee: null,
      dateFinTarifSelectionneeFormat : null,
      dateFinTarifSelectionnee: null,
      vueProduitComplementaire: {
        produitId: '',
        tarifId: '',
        familleId: '',
        fournisseurId: '',
        codeFamille: '',
        nomFamille: '',
        designation: '',
        grammage: 0,
        ingredientId: null,
        nomIngredient: '',
        uc: '',
        marque: '',
        reference: '',
        pcb: '',
        pu: null,
        allergenesMajeurs: [],
        aucunAllergene: false,
        nbKg: '',
        nbPCE: '',
        nbL: '',
        tauxTVA: 0
      },
      vueProduitComplementaireInitiale: {},
      optionsFamilles: [],
      listeFournisseurs: [],
      optionsFournisseurs: [],
      optionsTVA: [],
      article: {},
      familleSelect: {},
      fournisseurSelect: {},
      ingredientSelect: {},
      allergenesSelect: [],
      ucSelect: {},
      tvaSelect: {},
      listeIngredients: {},
      titreModal: "",
      titreBoutonOk: ""
    }
  },
  computed: {
    ...mapGetters("definitions", ["ingredients", "obtenirFamille"]),
    ...mapGetters("fournisseurs", ["fournisseursCourants"]),
    montantHT() {
      this.key
      if (this.vueProduitComplementaire.prixUnitaireHT && this.vueProduitComplementaire.pcb && this.ucSelect.id) {
        return arrondiPrixPCB(this.vueProduitComplementaire.pcb, this.vueProduitComplementaire.pcb, this.vueProduitComplementaire.prixUnitaireHT, 3) + this.unitePrix(this.vueProduitComplementaire.pcb)
      } else {
        return 0 + " €"
      }
    },
    montantTTC() {
      this.key
      if (this.vueProduitComplementaire.prixUnitaireHT && this.vueProduitComplementaire.pcb && this.ucSelect.id && (this.tvaSelect.id || this.tvaSelect.id === 0)) {
        return arrondiPrixPCB(this.vueProduitComplementaire.pcb, this.vueProduitComplementaire.pcb, (this.vueProduitComplementaire.prixUnitaireHT * (1 + (this.tvaSelect.id / 100))), 3) + this.unitePrix(this.vueProduitComplementaire.pcb)
      } else {
        return 0 + " €"
      }
    },
    puTTC() {
      this.key
      if (this.tvaSelect.id)
        return arrondiNombre(this.vueProduitComplementaire.prixUnitaireHT * (1 + (this.tvaSelect.id / 100)), 3)
      else
        return this.vueProduitComplementaire.prixUnitaireHT
    },
    ajouterOK() {
      this.key
      let valideProduit = this.vueProduitComplementaire.familleId && this.vueProduitComplementaire.uc
      let valideFournisseur = this.vueProduitComplementaire.fournisseurId && this.vueProduitComplementaire.designation && this.vueProduitComplementaire.prixUnitaireHT && this.vueProduitComplementaire.pcb && this.vueProduitComplementaire.allergenesMajeurs && this.vueProduitComplementaire.allergenesMajeurs.length > 0 && !this.allergenesKO
      return valideProduit && valideFournisseur
    },
    repartitionOK() {
      this.key
      return (this.vueProduitComplementaire.nbKg || this.vueProduitComplementaire.nbKg === 0) && (this.vueProduitComplementaire.nbPCE || this.vueProduitComplementaire.nbPCE === 0) && (this.vueProduitComplementaire.nbL || this.vueProduitComplementaire.nbL === 0)
    },
    allergenesKO() {
      this.key
      return this.vueProduitComplementaire.allergenesMajeurs.find(a => a === "Aucun Allergène") && this.vueProduitComplementaire.allergenesMajeurs.length > 1
    },
    produitEstModifiee() {
      this.key
      if (!this.vueProduitComplementaireInitiale) {
        return true
      }
      return !_.isEqual(JSON.stringify(this.vueProduitComplementaire), JSON.stringify(this.vueProduitComplementaireInitiale))
    },
    mercurialeModifiable() {
      return this.dateDebutTarifSelectionnee > this.formatDatePourApiSansSeparation(new Date())
    }
    
  },
  methods: {
    plurielUC(val, uc) {
      return plurielUC(val, uc)
    },
    unitePrix(pcb) {
      if (pcb && this.ucSelect.id) {
        return " / " + pcb + " " + this.plurielUC(pcb, this.ucSelect.id)
      } else {
        return " "
      }
    },
    phraseConversion(donneeFour, produit, qteCmd) {
      //pcb, uc, nbPCE, nbKg, nbL, qteCmd
      return phraseConversion(donneeFour.pcb, produit.uc, donneeFour.nbPCE, donneeFour.nbKg, donneeFour.nbL, qteCmd)
    },
    resetProduit() {
      this.vueProduitComplementaire = {}
      this.vueProduitComplementaire.ingredient = null
      this.vueProduitComplementaire.produitId = ''
      this.vueProduitComplementaire.familleId = this.familleSelect.valeur
      this.vueProduitComplementaire.designation = ''
      this.vueProduitComplementaire.grammage = 0
      this.vueProduitComplementaire.uc = ''
      this.vueProduitComplementaire.hierarchie = 1
      this.vueProduitComplementaire.tauxTVA = 0
      this.vueProduitComplementaire.fournisseurId = this.fournisseurSelect.valeur
      this.vueProduitComplementaire.tarifId = ''
      this.vueProduitComplementaire.marque = ''
      this.vueProduitComplementaire.reference = ''
      this.vueProduitComplementaire.prixUnitaireHT = 0
      this.vueProduitComplementaire.pcb = ''
      this.vueProduitComplementaire.allergenesMajeurs = []
      this.vueProduitComplementaire.aucunAllergene = false
      this.vueProduitComplementaire.nbKg = ''
      this.vueProduitComplementaire.nbPCE = ''
      this.vueProduitComplementaire.nbL = ''
      this.vueProduitComplementaire.dateDebut = this.obtenirDate(this.dateDebutTarifSelectionnee)
      this.vueProduitComplementaire.dateFin = this.obtenirDate(this.dateFinTarifSelectionnee)
      
    },
    majIngredientSelect() {
      if (this.ingredientSelect && this.ingredientSelect.ingredientId) {
        this.vueProduitComplementaire.ingredientId = this.ingredientSelect.ingredientId
        this.vueProduitComplementaire.ingredient = this.ingredientSelect.nomIngredient
      } else {
        this.vueProduitComplementaire.ingredientId = null
        this.vueProduitComplementaire.ingredient = null
      }
    },
    formatDonneeArticle() {
      //pour mettre à jour l'ingredient  et gestion allergene et les dates
      this.majIngredientSelect()

      if (this.vueProduitComplementaire.allergenesMajeurs.find(a => a === "Aucun Allergène"))
        this.vueProduitComplementaire.aucunAllergene = true

      this.vueProduitComplementaire.dateDebut = this.obtenirDate(this.dateDebutTarifSelectionnee)
      this.vueProduitComplementaire.dateFin = this.obtenirDate(this.dateFinTarifSelectionnee)
    },
    initialiserModale() {
      this.ajoutProduit = false
      this.modifierProduit = false
      this.dupliquerProduit = false

      this.ajoutTarif = false
      this.selectionFournisseur = true

      this.ingredientSelect = {}

      switch(this.paramModale.modeAffichage) {
        case "ajoutProduit":
          this.ajoutProduit = true
          this.titreModal = "Ajouter un produit complémentaire pour le " + this.dateDebutTarifSelectionneeFormat
          this.titreBoutonOk = "Ajouter"
          break;
        case "modifierProduit":
          this.modifierProduit = true
          this.titreModal = "Modifier un produit complémentaire pour le " + this.dateDebutTarifSelectionneeFormat
          this.titreBoutonOk = "Modifier"
          break;
        case "dupliquerProduit":
          this.dupliquerProduit = true
          this.titreModal = "Dupliquer un produit complémentaire"
          this.titreBoutonOk = "Ajouter"
          break;
      }

      if (this.ajoutProduit) {
        this.ucSelect = {}
        this.tvaSelect = {}
        
        this.resetProduit()
      } else {
        this.vueProduitComplementaire = _.cloneDeep(this.produitComplementaire)

        if (this.vueProduitComplementaire.aucunAllergene && this.vueProduitComplementaire.allergenesMajeurs.length === 0)
            this.vueProduitComplementaire.allergenesMajeurs.push("Aucun Allergène")

        this.ucSelect = this.optionsUC.find(u => u.id === this.vueProduitComplementaire.uc)
        this.tvaSelect = this.optionsTVA.find(opt => opt.id === this.vueProduitComplementaire.tauxTVA)

        if (this.vueProduitComplementaire.ingredientId && this.vueProduitComplementaire.ingredient) {
          this.ingredientSelect.ingredientId = this.vueProduitComplementaire.ingredientId
          this.ingredientSelect.nomIngredient = this.vueProduitComplementaire.ingredient
        }
      }
      this.vueProduitComplementaireInitiale = _.cloneDeep(this.vueProduitComplementaire)

      this.key++
    },

    resetIngredient() {
      this.ingredientSelect = {}
      this.vueProduitComplementaire.ingredientId = null
      this.vueProduitComplementaire.ingredient = null
    },
    async enregistrerProduit() {
      this.$store.commit('uxHelpers/showSpinner')

      this.formatDonneeArticle()

      await ajouterModifierProduitComplementaire(this.vueProduitComplementaire)
/*
      if (this.ajoutProduit || this.dupliquerProduit) {
        let resultat = await ajouterProduitHM(this.article)
        this.article = resultat.data
      } else if (this.modifierProduit) {
        this.article.produits[0].produitId = this.vueProduitComplementaire.produitId
        this.article.produits[0].tarifs[0].tarifId = this.donneeFournisseur.tarifId
        await modifierProduitHM(this.article)
      }
      */
      this.$emit("produit-modifie")
      this.$store.commit('uxHelpers/hideSpinner')
      
      this.alerteSucces("Produit sauvegardé !")
    },
    obtenirDate(dt) {
      //reconstruit une date au format AAAAMMJJ en objet date
      let year  = dt.substring(0, 4);
      let month = dt.substring(4, 6); // attention : 0 = janvier
      let day   = dt.substring(6, 8);
      
      return new Date(year, month - 1, day, 12, 0, 0);
    },
    show(listeFamille, listeFournisseur, famId, fourId, dtDebutTarif, dtFinTarif) {
      this.optionsFamilles = listeFamille
      this.optionsFournisseurs = listeFournisseur
      this.dateDebutTarifSelectionnee = dtDebutTarif
      this.dateFinTarifSelectionnee = dtFinTarif

      this.dateDebutTarifSelectionneeFormat = this.formatHumanDateAvecSlashes(this.obtenirDate(dtDebutTarif))
      this.dateFinTarifSelectionneeFormat = this.formatHumanDateAvecSlashes(this.obtenirDate(dtFinTarif)) //si on doit l'utilser ....

      this.familleSelect = this.optionsFamilles.find(f => f.valeur === famId)
      this.fournisseurSelect = this.optionsFournisseurs.find(f => f.valeur === fourId)

      this.$refs.modalAjoutProduitComplementaire.show()
    },
    hide() {
      this.$refs.modalAjoutProduitComplementaire.hide()
    },
    selectUCDeProduit(event) {
      this.vueProduitComplementaire.uc = event.id
      if (this.vueProduitComplementaire.pcb) {
        if (event.id === "Kg") 
          this.vueProduitComplementaire.nbKg = this.vueProduitComplementaire.pcb
        if (event.id === "Litre")
          this.vueProduitComplementaire.nbL = this.vueProduitComplementaire.pcb
        if (event.id === "Pièce")
          this.vueProduitComplementaire.nbPCE = this.vueProduitComplementaire.pcb
      } else {
        this.vueProduitComplementaire.nbKg = null
        this.vueProduitComplementaire.nbL = null
        this.vueProduitComplementaire.nbPCE = null
      }
    },
    selectTVA(event) {
      this.vueProduitComplementaire.tauxTVA = event.id
    },
    construireListeTVA() {
      let liste = []
      liste.push({id: 0, nom: "0"})
      liste.push({id: 5.5, nom: "5.5"})
      liste.push({id: 10, nom: "10"})
      liste.push({id: 20, nom: "20"})

      return liste
    },
    
  },
  async mounted() {
    this.optionsTVA = this.construireListeTVA()
    this.tvaSelect = this.optionsTVA[0]
    this.optionsAllergenes = constantesId.allergenes
    if (!this.optionsAllergenes.find(a => a.id === "Aucun Allergène"))
      this.optionsAllergenes.unshift({id: "Aucun Allergène", valeur: "Aucun Allergène"})

    this.key++
  }
}
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
